import { MaskedInputProps } from '@stone-payments/jade';

export type DocumentType = 'CNPJ' | 'CPF' | 'passport';

export type DocumentInputProp = {
  documentType: 'CNPJ' | 'CPF' | 'passport';
};

export const documentMask: Record<
  Exclude<DocumentInputProp['documentType'], 'passport'>,
  MaskedInputProps['mask']
> = {
  CPF: 'cpf',
  CNPJ: 'cnpj',
};

export const documentPlaceholder = {
  CPF: '000.000.000-00',
  CNPJ: '12.ABC.345/01DE-35',
  passport: 'AA00000',
};

export const documentTypesKeys: Array<Lowercase<DocumentType>> = [
  'cpf',
  'cnpj',
  'passport',
];

export const DOCUMENT_TYPE: Record<string, DocumentType> = {
  CPF: 'CPF',
  CNPJ: 'CNPJ',
  PASSPORT: 'passport',
};

export const isCpf = (type?: string): boolean =>
  type?.toLowerCase() === DOCUMENT_TYPE.CPF.toLowerCase();
export const isCnpj = (type?: string): boolean =>
  type?.toLowerCase() === DOCUMENT_TYPE.CNPJ.toLowerCase();

export const isPassport = (type?: string): boolean =>
  type?.toLowerCase() === DOCUMENT_TYPE.PASSPORT.toLowerCase();

